class DecimalUtil {
    static toFixedNoRouding(value: number, precison?: number): number {
        const precisionCustom = (precison || 2);

        const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + precisionCustom + "})?", "g")
        const a = (value.toString().match(reg) || [])[0];
        const dot = a.indexOf(".");
        if (dot === -1) { // integer, insert decimal dot and pad up zeros
            return Number(a + "." + "0".repeat(precisionCustom));
        }
        const b = precisionCustom - (a.length - dot) + 1;
        return Number(b > 0 ? (a + "0".repeat(b)) : a);
    }

    static toFixed(value: number, precison?: number): number {
        return Number(value.toFixed(precison || 2));
    }

    static decimal(value: number, decimalPlaces: number = 2, defaultValue: string = "-"): string {
        if (!value) {
            return defaultValue;
        }

        return Number(value.toFixed(decimalPlaces)).toLocaleString("pt-BR", { minimumFractionDigits: decimalPlaces });
    }
}

export { DecimalUtil }